import { render, staticRenderFns } from "./ResultView.vue?vue&type=template&id=58ea32c5"
import script from "./ResultView.vue?vue&type=script&lang=ts"
export * from "./ResultView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports